import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { SelectOption } from '@models/ui-models/select-options';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonModalFormComponent } from "@shared/components/commons/common-modal-form/common-modal-form.component";
import { AutocompleteComponent } from "@shared/controls/autocomplete/autocomplete.component";
import { SelectComponent } from "@shared/controls/select/select.component";
import { OrganisationApiService } from "@shared/services/organisation-api.service";
import { ToastrService } from 'ngx-toastr';
import { SuperuserApiService } from '../../../../services/superuser-api.service';

@Component({
  selector: 'app-officer-contact-edit',
  standalone: true,
  imports: [
    CommonModalFormComponent,
    SelectComponent,
    FormsModule,
    AutocompleteComponent
  ],
  providers: [SuperuserApiService],
  templateUrl: 'publish-organisation-signal-modal.component.html',
})
export class PublishOrganisationSignalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  organisationService = inject(OrganisationApiService);
  superuserService = inject(SuperuserApiService);
  toastr = inject(ToastrService);

  @Input({ required: true }) organisations!: SelectOption[];
  @Input() orgId: string | null = null;
  @Input() useSecondary = false;

  @Output() confirm = new EventEmitter<boolean>();

  readonly mailboxes = [
    { label: 'Primary', value: false },
    { label: 'Secondary', value: true }
  ];

  isLoading = signal(false);

  ngOnInit(): void {
    this.orgId = this.organisationService.getCachedProfile()?.organisationId ?? null;
  }

  publish(): void {
    if (!this.orgId) return;
    this.isLoading.set(true);

    this.superuserService.publishOrganisationSignal(this.orgId, this.useSecondary).subscribe({
      next: () => {
        this.toastr.success('Signal published successfully');
        this.confirm.emit(true);
        this.activeModal.close();
      },
      error: (error) => {
        this.isLoading.set(false);
        console.error(error);
        this.toastr.error('Failed to publish signal', 'Error');
      }
    });
  }

  close(): void {
    this.activeModal.close();
  }
}
